export const sortToPersian = {
  lastest: 'جدیدترین',
  cheapest: 'ارزان ترین',
  most_expensive: 'گران ترین',
  nearest: 'نزدیک ترین',
};
